(() => {
  const ROOT_SELECTOR = '[data-ep-tabs]';
  const TAB_SELECTOR = '[data-ep-tab]';
  const PANEL_SELECTOR = '[data-ep-panel]';

  function initialize(root) {
    if (!root || root.dataset.epTabsInitialized === 'true') return;

    const tabList = root.querySelector('[data-ep-tab-list]');
    const tabs = Array.from(root.querySelectorAll(TAB_SELECTOR));
    const panels = Array.from(root.querySelectorAll(PANEL_SELECTOR));

    if (!tabList || !tabs.length || tabs.length !== panels.length) return;

    const panelById = new Map(panels.map((panel) => [panel.id, panel]));
    const tabForPanelId = new Map(
      tabs.map((tab) => [tab.getAttribute('href')?.replace(/^#/, ''), tab])
    );

    let initialTab = tabs[0];
    const hash = window.location.hash.replace(/^#/, '');
    if (hash && tabForPanelId.has(hash)) initialTab = tabForPanelId.get(hash);

    root.classList.add('is-enhanced');
    tabList.setAttribute('role', 'tablist');

    tabs.forEach((tab) => {
      const panelId = tab.getAttribute('href')?.replace(/^#/, '');
      const panel = panelById.get(panelId);
      if (!panel) return;

      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      panel.setAttribute('tabindex', '0');
    });

    function activate(tab, { focus = false } = {}) {
      if (!tab) return;

      tabs.forEach((candidate) => {
        const isActive = candidate === tab;
        const panelId = candidate.getAttribute('href')?.replace(/^#/, '');
        const panel = panelById.get(panelId);

        candidate.classList.toggle('is-active', isActive);
        candidate.setAttribute('aria-selected', isActive ? 'true' : 'false');
        candidate.setAttribute('tabindex', isActive ? '0' : '-1');

        if (panel) panel.hidden = !isActive;
      });

      if (focus) tab.focus();
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        activate(tab);
      });

      tab.addEventListener('keydown', (event) => {
        let nextIndex = null;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === null) return;

        event.preventDefault();
        activate(tabs[nextIndex], { focus: true });
      });
    });

    activate(initialTab);
    root.dataset.epTabsInitialized = 'true';
  }

  function initializeAll(scope = document) {
    if (scope.matches?.(ROOT_SELECTOR)) initialize(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initialize);
  }

  initializeAll();
  document.addEventListener('DOMContentLoaded', () => initializeAll());

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest?.(PANEL_SELECTOR);
    if (!panel) return;

    const root = panel.closest(ROOT_SELECTOR);
    if (!root) return;

    initialize(root);
    const tab = root.querySelector(`${TAB_SELECTOR}[data-block-id="${panel.dataset.blockId}"]`);
    if (tab) tab.click();
  });
})();
